import { useEffect } from 'react';
import { useProgramsStore } from '@/shared/stores/programsStore';

export function useAllTeamsGlobal() {
  const allTeamsGlobal = useProgramsStore(s => s.allTeamsGlobal);
  const isLoading = useProgramsStore(s => s.isLoadingGlobalTeams);
  const error = useProgramsStore(s => s.globalTeamsError);
  const loadAllTeamsGlobal = useProgramsStore(s => s.loadAllTeamsGlobal);

  useEffect(() => {
    loadAllTeamsGlobal();
  }, [loadAllTeamsGlobal]);

  return { allTeamsGlobal, isLoading, error };
}
